import apiClient from '../apiClient';
import { POST_TOUR_OPERATOR_URL } from '../apiUrl';

const postTourOperatorApi = data => {
  return apiClient.post(POST_TOUR_OPERATOR_URL, data);
};

export default postTourOperatorApi;
